import { useLazyQuery } from '@apollo/client';
import SearchMealsQuery from './SearchMealsQuery';
import {
  CookbookMealSearchEdge,
  MealsSearchCriteriaInputType,
  SearchMealsQueryResult,
  SearchVariables,
} from '../types';

interface ICookbookSearchConnectorApollo {
  children: ({
    searchCookbookMeals,
    loading,
    meals,
    called,
  }: {
    searchCookbookMeals: (searchCriteria?: MealsSearchCriteriaInputType) => Promise<any>;
    loading: boolean;
    meals: CookbookMealSearchEdge[];
    called: boolean;
  }) => JSX.Element;
}

const CookbookSearchConnectorApollo: React.FC<ICookbookSearchConnectorApollo> = ({ children }) => {
  const [searchMeals, { loading, data, called }] = useLazyQuery<
    SearchMealsQueryResult,
    SearchVariables
  >(SearchMealsQuery);

  const createSearchMeals = async (searchCriteria?: MealsSearchCriteriaInputType) => {
    const result = await searchMeals({ variables: { searchCriteria } });

    return result;
  };

  return children({
    searchCookbookMeals: createSearchMeals,
    loading,
    meals: data?.cookbook.meals.edges || [],
    called,
  });
};

export default CookbookSearchConnectorApollo;
